module.exports = __webpack_public_path__ + "img/osint-logo-side.9ce714b2.png";